import React, { useState } from "react";
import ReactPlayer from "react-player";
import EditOptionModal from "../Modal/EditOptionModal";
import Modal from "../Modal/Modal";
import RemovePollOption from "../Modal/RemovePollOption";
import imagePlug from "../../../src/zaslepka.jpg";

import styles from "../../pages/SingleVoting/SingleVoting.module.scss"
import { singleTag } from "../../tools/interfaces";


interface Props {
    data: {
        title: string,
        artist: string,
        image: string,
        file: string,
        content: string,
        id: number,
        smsCode: string,
        order: number,
        tagId: number
    }
    pollId: string | undefined,
    tagList: Array<singleTag>,
    setOptions: (arg: []) => void,
    index: number,
    votingFrom: string | undefined
}

const OptionTable: React.FC<Props> = ({ data, pollId, tagList, setOptions, index, votingFrom }) => {
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    const getTagName = (tag: any) => {
        return tag.id === data.tagId
    }

    const tagName = tagList.find(getTagName)?.name;

    const checkIfStarted = () => {
        if (votingFrom !== undefined) {
            return new Date() < new Date(votingFrom);
        } else {
            return false;
        }
    }

    const tagStyles = (tag: string | undefined) => {
        if (tag === "Nowość") {
            return {
                backgroundColor: "#7E20CE",
                color: "white",
                marginBottom: "10px",
                padding: "5px 10px",
                width: "fit-content",
                borderRadius: "8px"
            }
        } else if (tag === "Propozycja") {
            return {
                backgroundColor: "#E4C8D1",
                color: "black",
                marginBottom: "10px",
                padding: "5px 10px",
                width: "fit-content",
                borderRadius: "8px"
            }
        } else {
            return {
                marginBottom: "10px",
                padding: "5px 5px"
            }
        }
    }


    return (
        <div className={styles.option}>
            <div className={styles.orderBox}>
                {
                    index + 1 < 10 ? `0${index + 1}` : index + 1
                }
            </div>
            <div className={styles.leftSide}>
                <div className={styles.option__image}>
                    <img src={!data.image ? imagePlug : data.image} alt="obrazek opcji" width={255} />
                </div>
            </div>
            <div className={styles.rightSide}>
                <div className={styles.rightSideTop}>
                    <div className={styles.option__artist}>
                        {data.artist}
                    </div>
                    <div className={styles.option__title}>
                        {data.title}
                    </div>
                    <div style={tagStyles(tagName)}>
                        Tag: {tagName}
                    </div>
                    <div className={styles.contentBox}>
                        <div className={styles.option__content}>
                            {data.content}
                        </div>
                        <div className={styles.option__sms}>
                            KOD SMS: <p style={{ fontWeight: "700", color: "#000" }}>&nbsp;{data.smsCode}</p>
                        </div>
                    </div>
                </div>
                <div className={styles.rightSideBottom}>
                    <div className={styles.option__file}>
                        {data.file ? (
                            <div>
                                <ReactPlayer
                                    url={data.file}
                                    controls={true}
                                    height="70px"
                                    width="360px"
                                    config={{
                                        file: {
                                            forceAudio: true
                                        }
                                    }}
                                />
                            </div>
                        ) : (
                            <div>
                                <p className={styles.noContentError}>Brak pliku mp3!</p>
                            </div>
                        )}
                    </div>
                    {checkIfStarted() && <div className={styles.buttonsBox}>
                        <button
                            className={styles.btnEditOpt}
                            onClick={(e) => {
                                e.preventDefault();
                                setShowEdit(true);

                            }
                            }>Edytuj</button>
                        <button
                            className={styles.btnDeleteOpt}
                            onClick={(e) => {
                                e.preventDefault();
                                setShowDelete(true);
                            }
                            }>Usuń</button>
                    </div>}
                </div>
            </div>
            {showEdit && (
                <Modal openModal={setShowEdit}>
                    <EditOptionModal
                        data={data}
                        openModal={setShowEdit}
                        pollId={pollId}
                        tagList={tagList}
                        setOptions={setOptions}
                    />
                </Modal>
            )
            }
            {showDelete && (
                <Modal openModal={setShowDelete}>
                    <RemovePollOption
                        pollId={parseInt(pollId as string)}
                        optionId={data.id}
                        openModal={setShowDelete}
                        setOptions={setOptions}
                    />
                </Modal>
            )
            }
        </div>
    )
}

export default OptionTable;